const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="11"
        fill="white"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M21.1794 23.9995V21.5518C21.1794 18.848 19.1246 16.6562 16.5899 16.6562H7.41083C4.8761 16.6562 2.82129 18.848 2.82129 21.5518V23.9995"
        stroke="#20458F"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <ellipse
        cx="12"
        cy="9.06146"
        rx="3.5"
        ry="3.73333"
        stroke="#20458F"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default UserIcon
